/**
 * handles the state of the
 * product definition bookmarks
 * of a user and synchronizes it
 * with the api
 **/
import ProductDefinitionBookmarkService from '@/classes-internal/bookmark/ProductDefinitionBookmarkService'

const state = () => ({
  bookmarks: [],
  service: new ProductDefinitionBookmarkService(),
})

// getters
const getters = {
  bookmarks: (state) => {
    return state.bookmarks
  },
  getBookmarkByProdDefId: (state) => (prodDefId) => {
    const bookmark = state.bookmarks.find((bookmark) => {
      return bookmark.prodDefIds.includes(prodDefId)
    })
    return bookmark
  },
}

// actions
const actions = {
  /**
   * get bookmarks from api
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async loadBookmarks({ commit, state }) {
    const bookmarks = await state.service.fetch()
    commit('setBookmarks', bookmarks)
  },
  /**
   * sync the bookmarks with the api
   * @param commit
   * @param state
   * @returns {Promise<void>}
   */
  async updateBookmarks({ commit, state }) {
    const bookmarks = await state.service.update(state.bookmarks)
    commit('setBookmarks', bookmarks)
  },
}

// mutations
const mutations = {
  setBookmarks(state, bookmarks) {
    state.bookmarks = bookmarks
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
